import { render } from "./PortalGrupoFamiliar.vue?vue&type=template&id=05b77bc0&scoped=true"
import script from "./PortalGrupoFamiliar.vue?vue&type=script&lang=js"
export * from "./PortalGrupoFamiliar.vue?vue&type=script&lang=js"

import "./PortalGrupoFamiliar.vue?vue&type=style&index=0&id=05b77bc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b77bc0"]])

export default __exports__